import { render } from "./Burger.vue?vue&type=template&id=f68d5efe"
import script from "./Burger.vue?vue&type=script&lang=js"
export * from "./Burger.vue?vue&type=script&lang=js"

import "./Burger.vue?vue&type=style&index=0&id=f68d5efe&lang=css"
script.render = render

export default script